/**
 * The ONE place the staff "open this family's record" link is built.
 *
 * Every record in `memberships` — member, customer or LEAD — opens the same
 * staff membership page. A lead is a membership row with account_type='lead';
 * it has notes, tasks, message history and send-email like anyone else.
 *
 * Until 2026-10-08 the sidebar search (and three other links) sent a lead to
 * the Lead Pipeline side panel instead, so staff converted leads to members
 * just to be able to work with them — and conversion creates invoices the
 * family never agreed to (Chris, 2026-10-07). Do not branch on account type
 * when linking to a record: use this.
 */
export function membershipPagePath(tenantSlug: string | null | undefined, membershipId: string): string {
  const prefix = tenantSlug ? `/${tenantSlug}` : "";
  return `${prefix}/manage/memberships/${membershipId}`;
}

/**
 * The Lead Pipeline with one lead's side panel open. Only for links that are
 * ABOUT the pipeline (stage, convert) — not for "open this person".
 * `convert` opens the Convert to Member dialog straight away.
 */
export function leadPipelinePath(
  tenantSlug: string | null | undefined,
  leadId: string,
  opts: { convert?: boolean } = {}
): string {
  const prefix = tenantSlug ? `/${tenantSlug}` : "";
  return `${prefix}/manage/crm/leads?lead=${leadId}${opts.convert ? "&convert=1" : ""}`;
}
